module.exports = __webpack_public_path__ + "static/media/video.ffcd876c.mp4";